// PERF: Extracted from theme.liquid to reduce inline script size
// Cart quantity update functionality
(function() {
  'use strict';

  // Function to update quantity in .cart-item-code
  function updateCartItemCodeQuantity() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const totalQuantity = cart.item_count;
        document.querySelectorAll('.cart-item-code').forEach((el) => {
          el.textContent = totalQuantity;
        });
      })
      .catch((error) => {
        // Silently fail if cart fetch fails
        console.error('Cart quantity update failed:', error);
      });
  }

  // Run on initial page load
  document.addEventListener('DOMContentLoaded', () => {
    updateCartItemCodeQuantity();
    observeCartChanges();
  });

  // Use a MutationObserver to detect DOM changes in cart (useful for drawers too!)
  function observeCartChanges() {
    const target = document.querySelector('.ajaxcart, .ajaxcart__main, .ajaxcart__products');

    if (!target) return;

    const observer = new MutationObserver(() => {
      setTimeout(updateCartItemCodeQuantity, 300); // slight delay for DOM updates
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
    });
  }

  // Optional: manual refresh event hook
  document.addEventListener('cart:refresh', () => {
    updateCartItemCodeQuantity();
  });
})();
